import { render, staticRenderFns } from "./ReservationBlock.vue?vue&type=template&id=4d96d721&scoped=true&"
import script from "./ReservationBlock.vue?vue&type=script&lang=js&"
export * from "./ReservationBlock.vue?vue&type=script&lang=js&"
import style0 from "./ReservationBlock.vue?vue&type=style&index=0&id=4d96d721&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d96d721",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
